<ion-row class="ion-margin-top">
    <ion-col class="ion-no-padding" size="12">
        <ion-label color="dark">
            <h2 class="ion-no-margin ion-text-center"><b>{{ value }}</b></h2>
        </ion-label>
    </ion-col>
</ion-row>